<template lang="pug">
.topic-create-close(@click="clickIsCreate()")
  svg.topic-create-close__icon
    use(xlink:href="#faq-plus")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Close',

  computed: {
    ...mapGetters([
      'isCreate'
    ])
  },

  methods: {
    ...mapMutations([
      'changeIsCreate'
    ]),

    clickIsCreate () {
      this.changeIsCreate(!this.isCreate)
    }
  }
}
</script>
